import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Box.css';

const propTypes = {
    className: PropTypes.string,
    addPadding: PropTypes.bool,
    addShadow: PropTypes.bool,
};

export class Box extends React.Component {
    static defaultProps = {
        addPadding: false,
        addShadow: false,
    };

    render() {
        return (
            <div
                className={classNames(
                    s.box,
                    {
                        [s.padding]: this.props.addPadding,
                        [s.shadow]: this.props.addShadow,
                    },
                    this.props.className
                )}
            >
                {this.props.children}
            </div>
        );
    }
}

Box.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/containers/Box.jsx